import { render, staticRenderFns } from "./TabNavBar.vue?vue&type=template&id=54c2391a&"
import script from "./TabNavBar.vue?vue&type=script&lang=js&"
export * from "./TabNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c2391a')) {
      api.createRecord('54c2391a', component.options)
    } else {
      api.reload('54c2391a', component.options)
    }
    module.hot.accept("./TabNavBar.vue?vue&type=template&id=54c2391a&", function () {
      api.rerender('54c2391a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/ok-customer/components/TabNavBar.vue"
export default component.exports